module.exports = __webpack_public_path__ + "img/jaw.dcca7e67.jpg";